import { type SingleSelectedValueFilter } from '../types'
import DeadlineDateFilter from './DeadlineDateFilter'

const DeadlineDateAfterFilter = (props: SingleSelectedValueFilter) => {
  return (
    <DeadlineDateFilter {...props} rangeType='Deadline after' />
  )
}

export default DeadlineDateAfterFilter
